import React from 'react'

import { fetchMusicOffers } from 'features/search/pages/ThematicSearch/api/fetchMusicOffers'
import { useThematicSearchPlaylistsQuery } from 'features/search/pages/ThematicSearch/queries/useThematicSearchPlaylistsQuery'
import { ThematicSearchPlaylistList } from 'features/search/pages/ThematicSearch/ThematicSearchPlaylistList'
import { ThematicPlaylistProps } from 'features/search/types'
import { useFeatureFlag } from 'libs/firebase/firestore/featureFlags/useFeatureFlag'
import { RemoteStoreFeatureFlags } from 'libs/firebase/firestore/types'
import { useLocation } from 'libs/location/location'
import { QueryKeys } from 'libs/queryKeys'

const MUSIC_PLAYLISTS_TITLES = [
  'Musique en ligne',
  'Concerts',
  'Festivals',
  'Instruments de musique',
  'CDs',
  'Vinyles',
]

export const MusicPlaylists: React.FC<ThematicPlaylistProps> = ({
  shouldDisplayVenuesPlaylist,
  onViewableItemsChanged,
  searchId,
}) => {
  const isReplicaAlgoliaIndexActive = useFeatureFlag(
    RemoteStoreFeatureFlags.ENABLE_REPLICA_ALGOLIA_INDEX
  )
  const { userLocation } = useLocation()

  const { playlists: musicPlaylists, isLoading: areMusicPlaylistsLoading } =
    useThematicSearchPlaylistsQuery({
      playlistTitles: MUSIC_PLAYLISTS_TITLES,
      fetchMethod: () => fetchMusicOffers({ userLocation, isReplicaAlgoliaIndexActive }),
      queryKey: QueryKeys.MUSIC_OFFERS,
    })

  return (
    <ThematicSearchPlaylistList
      playlists={musicPlaylists}
      isLoading={areMusicPlaylistsLoading}
      shouldDisplayVenuesPlaylist={shouldDisplayVenuesPlaylist}
      onViewableItemsChanged={onViewableItemsChanged}
      searchId={searchId}
    />
  )
}
